var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-badge',{staticClass:"p-1 font-weight-normal",attrs:{"variant":"green"}},[_vm._v(" "+_vm._s(_vm.$t("general.entity.state." + _vm.value.state))+" ")]),(_vm.published)?_c('b-badge',{staticClass:"p-1 font-weight-normal",attrs:{"variant":"green"}},[_vm._v("V"+_vm._s(_vm.value.revision))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }